module.exports = __webpack_public_path__ + "img/slide9.83a08fe4.png";